import React, { FC } from 'react'

interface OptionProps {
    children: React.ReactNode
}

const Option: FC<OptionProps> = ({
    children
}) => {
    return (
        <div className="option__wrapper">
                {children}
        </div>
    )
}

export default Option
